export const LearningJourneyOptionalQuestionsCardQuestions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Share your reasons for attending this event",
        eventQuestionTypeId: 3,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Event topic is of interest to me",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Event venue is attractive",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Accumulating CPD points",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Others (please specify)",
                "isOther": true
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "What other locations would interest you?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "Would you like to be connected with the Learning Journey host(s)? Yes/No",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Yes",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "No",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: `Please fill in your details if you have answered "Yes" to be connected with the host(s).`,
        eventQuestionTypeId: 17,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
        placeholder: `Please fill in your details if you have answered "Yes" to be connected with the host(s).`
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Name",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Organisation",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Email Address",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
]